import PostAttachment from "./PostAttachment";

export default PostAttachment;